module.exports = global["Backbone"] = require("-!/home/ec2-user/msgetstarted/node_modules/imports-loader/index.js?this=>window,underscore,jquery!/home/ec2-user/msgetstarted/node_modules/imports-loader/index.js?this=>window!./backbone.controller.js");


// WEBPACK FOOTER //
// ./_common/_js/backbone-controller/backbone.controller.js